import React from "react";
import { useTranslate } from "hooks/translation-hooks";
import { DetailsPanel } from "../../CardsStyled";
import { AlternativeButton } from "globalStyles/Containers";
import { Link } from "react-router-dom";
import { routes } from "Routes/routesConfig";
import { useSelector } from "react-redux";
import { currentNotificationSelector } from "redux/selectors/currentNotification";
import { event } from "analytics";

export const ShowComments = () => {
  const t = useTranslate();
  const { missionOrderId } = useSelector(currentNotificationSelector);
  const sendEvent = () => {
    event("change_appointment", "appointment_confirmed");
  };

  return (
    <Link
      data-testid="decline_button-click"
      to={routes.SCHEDULE_APPOINTMENT.replace(":id", missionOrderId)}
      onClick={sendEvent}
    >
      <DetailsPanel>
        <AlternativeButton>
          {t("appointment_reschedule-button_change")}
        </AlternativeButton>
      </DetailsPanel>
    </Link>
  );
};

export default ShowComments;
